exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-link{cursor:pointer;text-decoration:underline}.save-button-container{position:relative;margin-top:auto;display:flex;justify-content:flex-end;padding:1rem}", ""]);

// exports
